<template>
<!-- 使用人信息-新建使用人 -->
    <div class="user">
        <p class="title">新建使用人</p>
        <div class="cardBox">
            <form action="">
                <p>
                    <span><img class="must_fill" src="../assets/icon_xinghao@2x.png">
                        姓名
                    </span>
                    <span>
                        <input v-model="name" type="text" name="firstname" maxlength="12" placeholder="请输入您的姓名">
                        <img src="../assets/icon_yellowpen@2x.png" alt="修改">
                    </span>
                </p>
                <p>
                    <span><img class="must_fill" src="../assets/icon_xinghao@2x.png">
                        性别
                    </span>
                    <span>
                        <input v-model="sex" type="text" name="sex" maxlength="2" placeholder="请输入您的性别">
                        <img src="../assets/icon_yellowpen@2x.png" alt="修改">
                    </span>
                </p>
                <p>
                    <span><img class="must_fill" src="../assets/icon_xinghao@2x.png">
                        手机号
                    </span>
                    <span>
                        <input type="text" v-model="phone" name="phone" maxlength="11" pattern="[0-9]" placeholder="请输入您的手机号">
                        <img src="../assets/icon_yellowpen@2x.png" alt="修改">
                    </span>
                </p>
                <p>
                    <span><img class="must_fill" src="../assets/icon_xinghao@2x.png">
                        生日
                    </span>
                    <span>
                        {{ birthday }}
                        <img @click="showTimePopup" src="../assets/icon_yellowpen@2x.png" alt="修改">
                    </span>
                </p>
                <p>
                    <span><img class="must_fill" src="../assets/icon_xinghao@2x.png">
                        年龄
                    </span>
                    <span>
                        {{ age }}
                        <!-- <img src="../assets/icon_yellowpen@2x.png" alt="修改"> -->
                    </span>
                </p>
            </form>
        </div>

        <button class="btnChange" @click="addUser">确认</button>

        <!-- 修改生日蒙层 -->
        <van-popup v-model="showTime" position="bottom">
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="timeSave"
            @cancel="onCancel"/>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import { DatetimePicker } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';

Vue.use(Toast);
Vue.use(Popup);
Vue.use(DatetimePicker);


export default {
    props: {

    },
    data() {
        return {
            name: '',
            sex: '',
            phone: '',
            birthday: '',
            age: '',
            showTime:false,
            currentDate: new Date(),
            minDate: new Date(1900,0,1),
            maxDate: new Date(),
        };
    },
    computed: {

    },
    created() {
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        addUser() {
            // 验证手机号
            let phone_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
            if(!phone_rule.test(this.phone)) {
                Toast('手机号错误！');
                return false
            }
            let myfilesex = this.sex =='男' ? 1 : 0
            if(this.sex != '男' && this.sex != '女') {
                Toast('请输入您的性别！')
                return false
            }

            if(this.name == '') {
                Toast('请输入您的名字！')
                return false
            }


            if(this.age == 0) {
                Toast('请输入您的生日！')
                return false
            }

            let data = {
                myfilename: this.name,
                myfilephone: this.phone,
                myfilesex,
                myfilebirthday: this.birthday,
                myfileage: this.age
            }

            this.axios.post('/weixin/addMyfile', data)
            .then(res=>{
                Dialog.alert({
                    message: '添加成功！'
                }).then(() => {
                    this.$router.push({path: '/UserInformation'})
                });
            })

        },
        // 判断是否是今天 (没用到)
        isToday(str){
            var d = new Date(str.replace(/-/g,"/"));
            var todaysDate = new Date();
            if(d.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)){
                return true;
            } else {
                return false;
            }
        },


        // 时间格式化
        formatter(type, value) {
        　　if (type === 'year') {
            　　return `${value}年`;
        　　} else if (type === 'month') {
        　　  return `${value}月`
        　　} else if (type === 'day') {
            　　return `${value}日`
        　　}
    　　    return value;
    　　},
        // 点击修改生日按钮
        showTimePopup(){
            this.showTime = true;
        },
        onCancel () {
            this.showTime = false;
        },
        timeSave(val) {
            this.birthday =  val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
            this.showTime = false;
            this.jsGetAge(this.birthday)
        },

        // 根据生日 计算年龄
        jsGetAge(strBirthday){
            var returnAge;
            var strBirthdayArr=strBirthday.split("-");
            var birthYear = strBirthdayArr[0];
            var birthMonth = strBirthdayArr[1];
            var birthDay = strBirthdayArr[2];

            var d = new Date();
            var nowYear = d.getFullYear();
            var nowMonth = d.getMonth() + 1;
            var nowDay = d.getDate();

            if(nowYear == birthYear){
                returnAge = 0;//同年 则为0岁
            }
            else{
                var ageDiff = nowYear - birthYear ; //年之差
                if(ageDiff > 0){
                    if(nowMonth == birthMonth) {
                        var dayDiff = nowDay - birthDay;//日之差
                        if(dayDiff < 0)
                        {
                            returnAge = ageDiff - 1;
                        }
                        else
                        {
                            returnAge = ageDiff ;
                        }
                    }
                    else
                    {
                        var monthDiff = nowMonth - birthMonth;//月之差
                        if(monthDiff < 0)
                        {
                            returnAge = ageDiff - 1;
                        }
                        else
                        {
                            returnAge = ageDiff ;
                        }
                    }
                }
                else
                {
                    returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
                }
            }
            return this.age = returnAge;//返回周岁年龄
        }


    },
    components: {

    },
};
</script>
<style>
.van-dialog__footer {
  height: 80px;
  line-height: 80px;
}
</style>

<style scoped>
input {
  border: none;
  width: 300px;
  text-align: right;
  font-size: 38px;
}

.cardBox {
  background: #fff;
  padding: 0 28px;
  border-radius: 30px;
}

.cardBox p{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 118px;
  border-bottom: 1px solid #f0f0f0;
}

.cardBox p:last-child {
  border-bottom: none;
}

.cardBox p span .must_fill {
    width: 12px;
    vertical-align: top;
}

.cardBox p span img {
  width: 30px;
  vertical-align: -1px;
}

.user {
    padding: 0 28px;
}

.user .title {
    margin: 30px 0;
}
.btnChange {
    width: 100%;
    height: 130px;
    letter-spacing: 4px;
    font-size: 44px;
    background-color: #eac645;
    color: #fff;
    border-radius: 25px;
    border: none;
    outline: none;
    margin-top: 254px;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

</style>



// WEBPACK FOOTER //
// src/views/NewUser.vue